import React from 'react';
import OverviewHelp from './OverviewHelp';
import FinOpsHelp from './FinOpsHelp';
import AnomaliesHelp from './AnomaliesHelp';
import TaggingHelp from './TaggingHelp';
import GuardrailsHelp from './GuardrailsHelp';
import CostRecommendationsHelp from './CostRecommendationsHelp';
import ComputeHelp from './ComputeHelp';
import EnvironmentsHelp from './EnvironmentsHelp';

type CloudOpsPage = 'overview' | 'finops' | 'anomalies' | 'tagging' | 'guardrails' | 'recommendations' | 'compute' | 'endpoints';

interface CloudOpsHelpProps {
  activePage: CloudOpsPage;
}

const CloudOpsHelp: React.FC<CloudOpsHelpProps> = ({ activePage }) => {
  switch (activePage) {
    case 'overview':
      return <OverviewHelp />;
    case 'finops':
      return <FinOpsHelp />;
    case 'anomalies':
      return <AnomaliesHelp />;
    case 'tagging':
      return <TaggingHelp />;
    case 'guardrails':
      return <GuardrailsHelp />;
    case 'recommendations':
      return <CostRecommendationsHelp />;
    case 'compute':
      return <ComputeHelp />;
    case 'endpoints':
      return <EnvironmentsHelp />;
    default:
      return <OverviewHelp />;
  }
};

export default CloudOpsHelp;
